import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { ITab } from '@uxdf/direct-shared-lib';

import { LayoutConfigService } from '../../../../modules/config-layout/services/config.service';
import { State } from '../../../../redux/reducers';
import { Reset as ResetReport } from '../../../../redux/actions/invoices/actions-segments-report';
import { Update as UpdateConfig } from '../../../../redux/actions/invoices/actions-segments-config';

@Component({
  standalone: false,
  selector: 'app-contracts-page',
  templateUrl: './contracts-page.component.html',
  styleUrls: ['./contracts-page.component.scss']
})
export class ContractsPageComponent implements OnInit {
  tabs: ITab[];
  showTabs = false;
  subtitle: string;

  constructor(
    private readonly layoutConfigService: LayoutConfigService,
    private readonly store: Store<State>,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.layoutConfigService
      .getModuleEnabledComponents('contract')
      .pipe(take(1))
      .subscribe(this.updateLayout.bind(this));

    this.store.dispatch(new ResetReport());
    this.store.dispatch(new UpdateConfig());
  }

  /**
   * Only tabs expected: either list or one tab as a whole page
   * Tab switch is managed by routing
   */
  private updateLayout(components: { [id: string]: boolean }) {
    this.router.navigate(['/account/contracts/documents'], { replaceUrl: true });
  }
}
